module.exports = __webpack_public_path__ + "img/sustainable_land.61de5e90.png";